import { render } from "./Confirm.vue?vue&type=template&id=10461df0&ts=true"
import script from "./Confirm.vue?vue&type=script&lang=ts"
export * from "./Confirm.vue?vue&type=script&lang=ts"

import "./Confirm.vue?vue&type=style&index=0&id=10461df0&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__